export default {
  managerFeedback: 'Manažér',
  placeholder: 'Pridať komentár...',
  noAttachments: 'Žiadne',
};
